import { styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

import { HEADER_TOGGLE_SIZE } from '../getActionPanelWidth'
import { panelIconButtonStyles } from '../ui'

export const ToggleButton = styled.button`
  --panel-icon-button-size: ${HEADER_TOGGLE_SIZE}px;

  ${panelIconButtonStyles}

  &:hover {
    background: ${Colors.Semantic.BStock.background.lightBackground};
    border-color: ${Colors.Semantic.BStock.onhover};
    color: ${Colors.Semantic.BStock.onhover};
  }
`
